// POST /templates/{templateCode}/generateReport
// templateCode - код шаблона (code из того, что ты кидал выше)
// name - наименование файла отчета
// types - массив с типами, которые тебе надо PDF, XLS и т.д.
//   parameters - объект с параметрами {<код параметра>: <значение параметра>}

import axios from "axios"
import env from "src/env"
import { showToast } from "@infotech/uikit-toasts"

import restRequest from "src/engine/modules/rest/api/request"

const { REACT_APP_REPORT_SERVICE_URL, REACT_APP_FILES_STORAGE_URL } = env

export const downloadFile = fileUrl => {
  // Dirty hack to initialize file download in browser with creating
  // virtual link and trigger click event on it
  const link = document.createElement(`a`)

  link.setAttribute(`href`, fileUrl)
  link.setAttribute(`download`, null)
  link.style.display = `none`
  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link)
}
const generateAndDownloadTemplates = (token, generateData, type, generate) => {
  const { templateCode, id } = generateData
  generate(true)
  // Запрашиваем имя отчета
  restRequest(
    `${REACT_APP_REPORT_SERVICE_URL}/templates/${templateCode}/makeReportName`,
    undefined,
    {
      method: `POST`,
      body: {
        planId: id,
      },
    },
  )
    // Запрос на генерацию отчета
    .then(result =>
      restRequest(
        `${REACT_APP_REPORT_SERVICE_URL}/templates/${templateCode}/generateReport`,
        undefined,
        {
          method: `POST`,
          body: {
            types: [type],
            name: result.data,
            parameterFields: [
              {
                name: `planId`,
                label: `planId`,
                props: {
                  attributeType: { code: `LONG` },
                },
              },
            ],
            parameters: {
              plan_id: id,
            },
          },
        },
      ),
    )
    .then(response => {
      // Пытаемся забрать сгенерируемый отчет
      const timerId = setInterval(() => {
        axios({
          method: `GET`,
          url: `${REACT_APP_REPORT_SERVICE_URL}/reports/${response.data.id}?token=${token}`,
        })
          .then(response => {
            const {
              files: {
                [type]: { status, file },
              },
            } = response.data
            if (status === `ERROR`) {
              setTimeout(() => {
                showToast({
                  type: `error`,
                  message: `Произошла ошибка при генерации отчета.`,
                  hideIn: 5,
                })
                generate(false)
                clearInterval(timerId)
              }, 0)
            }
            if (status === `EXECUTED`) {
              setTimeout(() => {
                // Скачиваем отчет, в случае со статусом EXECUTED
                generate(false)
                clearInterval(timerId)
                showToast({
                  type: `success`,
                  message: `Отчет в формате ${type} успешно сформирован. Скачивание файла начнется автоматически.`,
                  hideIn: 5,
                })
                downloadFile(
                  `${REACT_APP_FILES_STORAGE_URL}/files/${file.id}/content?token=${token}`,
                )
              }, 0)
            }
          })
          .catch(() =>
            setTimeout(() => {
              generate(false)
              clearInterval(timerId)
            }, 0),
          )
      }, 2000)
      setTimeout(() => {
        clearInterval(timerId)
      }, 60000)
    })
    .catch(() => generate(false))
}

export default generateAndDownloadTemplates
